import React from 'react';
import {
  Building2,
  MapPin,
  Eye,
  Plus
} from 'lucide-react';

const PropertyTableRow = ({
  property,
  index,
  isRetailManager,
  getPropertyImageUrl,
  getStatusColor,
  formatGLA,
  onOpenModal,
  onAssignAsset
}) => {
  return (
    <tr
      key={property.id || index}
      className="hover:bg-gray-50 cursor-pointer"
      onClick={() => onOpenModal(property)}
    >
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="w-16 h-16 rounded-lg overflow-hidden bg-gray-100 flex items-center justify-center">
          {getPropertyImageUrl(property) ? (
            <img
              src={getPropertyImageUrl(property)}
              alt={property.buildingName || property.building_name || 'Property Image'}
              className="w-full h-full object-cover"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.parentNode.innerHTML = `<div class='flex items-center justify-center h-full w-full'><div class='text-gray-400'>🏢</div></div>`;
              }}
            />
          ) : (
            <Building2 className="h-6 w-6 text-gray-400" />
          )}
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="font-medium text-gray-900">{property.buildingName || property.building_name || 'Unnamed Property'}</div>
        <div className="flex items-center space-x-2">
          <div className="text-sm text-gray-500">{property.sub_category}</div>
          {property.user_added && (
            <span className="inline-flex px-2 py-1 text-xs font-medium rounded-full bg-blue-100 text-blue-800">
              User Added
            </span>
          )}
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="text-gray-900">{property.sector || 'N/A'}</div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="text-gray-900">{formatGLA(property.building_gla)}</div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        <span className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${getStatusColor(property.status)}`}>
          {property.status}
        </span>
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="flex items-center text-gray-900">
          <MapPin size={14} className="mr-1 text-gray-400" />
          {property.city}, {property.province}
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="text-sm font-medium text-cyan-600">
          {property.asset_count || 0} assets
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-center">
        <button
          onClick={(e) => {
            e.stopPropagation();
            onOpenModal(property);
          }}
          className="text-cyan-600 hover:text-cyan-900 mr-3 p-2"
          title="View Property Details"
        >
          <Eye size={16} />
        </button>
        {!isRetailManager && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              onAssignAsset(property);
            }}
            className="text-green-600 hover:text-green-900 p-2"
            title="Assign Asset to Property"
          >
            <Plus size={16} />
          </button>
        )}
      </td>
    </tr>
  );
};

export default PropertyTableRow;
